import { store } from '@reducers/store';
import { observable, runInAction } from 'mobx';
/**
 * `appContext` lives in the `app` Redux slice, but `RootStore.app` is still a MobX computed that has
 * to re-evaluate when it changes. This mirrors the Redux value into an observable so MobX can track
 * it. Drop it once `RootStore.app` (the `search` / `prospecting` split) is migrated too.
 */
const appContextBox = observable.box(store.getState().app.appContext);
store.subscribe(() => {
    const nextAppContext = store.getState().app.appContext;
    if (appContextBox.get() !== nextAppContext) {
        runInAction(() => appContextBox.set(nextAppContext));
    }
});
export const getAppContext = () => appContextBox.get();
